export default "__VITE_PUBLIC_ASSET__09175df5__"